import { Injectable, NgModule, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { HttpModule, Http, ConnectionBackend, Request, RequestOptions, RequestOptionsArgs, Response, XHRBackend, Headers, RequestMethod, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
//import 'rxjs/Observable/bindCallback'
import { AdalService } from '../adal/adal.service';
//import { AdConfigService } from '../services/adconfig.service';
import { AppSettingsService } from './appsettings.service'; 
//import { ProgressBarService } from './progressbar.service'
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { NotificationsService } from 'angular2-notifications';
import { ApiResponse } from '../admin/apiresponse';

//@NgModule({
//    imports: [HttpModule]
//    //providers: [AdalService, AdConfigService]
//})
//export class AdalModule {
//    static withConfig(config?: AdalService, adConfig?: AppSettingsService): ModuleWithProviders {
//        return {
//            ngModule: AdalModule,
//            providers: [
//                provideAdalAuth(config, adConfig),
                
//            ]
//        }
//    }
//}

//export function provideAdalAuth(config?: AdalService, adConfig?: AppSettingsService): any[] {
//    return [
        
//        {
//            provide: Http, useFactory: (connectionBackend: XHRBackend, defaultOptions: RequestOptions, authService: AdalService, adConfigService: AppSettingsService) => {
//                return new AdalHttp(connectionBackend, defaultOptions, authService, adConfigService);
//            }, deps: [XHRBackend, RequestOptions, AdalService, AppSettingsService]
//        }
//    ];
//}

@Injectable()
export class AdalHttp extends Http {
    private currentRequests: number = 0;

    constructor(backend: ConnectionBackend,
        defaultOptions: RequestOptions,
        protected adalService: AdalService,
        protected adConfig: AppSettingsService,
        //protected progressBarService: ProgressBarService,
        protected progressBarService: SlimLoadingBarService,
        private notificationService: NotificationsService    ) {
        super(backend, defaultOptions);
        //adal.init(adConfig.adalConfig)
        this.currentRequests = 0;
    }

    get(url: string, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Get });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Post, body: body });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Delete });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }


    patch(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Patch, body: body });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    put(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Put, body: body });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    head(url: string, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Put });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    private sendRequest(url: string, options: RequestOptionsArgs): Observable<any> {
        //make a copy
        this.incrementRequestCount();
        let options1 = new RequestOptions();
        options1.method = options.method;

        if (options.search != null) {
            options1.search = new URLSearchParams(options.search.toString()).clone();
        }

        if (options.headers != null) {
            options1.headers = new Headers(options.headers.toJSON());
        }

        if (options.body != null) {
            options1.body = options.body;
        }

        var resource = this.adalService.GetResourceForEndpoint(url);
        var authenticatedCall: Observable<any>;


        if (resource) {

            if (this.adalService.userInfo.isAuthenticated) {
                if (this.adalService.getCachedToken(resource)) {
                    authenticatedCall = this.adalService.acquireToken(resource)
                        .flatMap((token: string) => {
                            if (options1.headers == null) {
                                options1.headers = new Headers();
                            }
                            options1.headers.append('Authorization', 'Bearer ' + token);
                            return super.request(url, options1)
                                .timeout(300000)
                                .map(response => this.extractData(response))
                                .do(this.decrementRequestCount)
                                .catch(err => { return this.handleError(err) });
                        });
                } else {
                    this.notificationService.info("Authentication failed", "Token expired, Please login again");
                    
                    authenticatedCall = Observable.throw(new Error("User Access Token expired."));
                    authenticatedCall.subscribe(() => { },
                        err => {
                            this.decrementRequestCount();
                            
                            setTimeout(() => {
                                this.adalService.logOut();
                            }, 5000);
                        });
                }
            }
            else {
                this.notificationService.info("Authentication failed", "User Not Authenticated, Please login");
                authenticatedCall = Observable.throw(new Error("User Not Authenticated."));
                authenticatedCall.subscribe(() => {},
                    err => {
                        this.decrementRequestCount();

                    });
            }
        }
        else {
            authenticatedCall = super.request(url, options).timeout(300000).map(this.extractData).catch(this.handleError);
        }

        return authenticatedCall;
    }

    private extractData(res: Response) {
        this.decrementRequestCount();
        if (res.status < 200 || res.status >= 300) {
            throw new Error('Bad response status: ' + res.status);
        }

        var body;
        //if there is some content, parse it
        if (res.status != 204) {
            body = res.json();
        }

        var httpStatus = res.status;
        var notificationMessage = body ? (body.Message ? body.Message: " ") : res.statusText;
        this.handleResponse(httpStatus, notificationMessage);

        var apiResponse = new ApiResponse();

        apiResponse.statusCode = res.status;
        //this.apiResponse.reasonPhrase = respBody.response.reasonPhrase;
        //this.apiResponse.isSuccess = respBody.response.isSuccessStatusCode;
        apiResponse.data = body;
        return apiResponse;
    }

    private handleError(error: any) {
        this.decrementRequestCount();

        var httpStatus = error.status;
        var responseMessage;
        try {
            responseMessage = error.json();
        } catch (e) {

        }
        var notificationMessage = responseMessage ? (responseMessage.Message ? responseMessage.Message : " ") : error.statusText;
        this.handleResponse(httpStatus, notificationMessage);
        // In a real world app, we might send the error to remote logging infrastructure
        //let errMsg = error.message || 'Server error';
        //console.error(JSON.stringify(error)); // log to console instead
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        var apiResponse = new ApiResponse();
        apiResponse.statusCode = error.status;
        apiResponse.reasonPhrase = error.statusText;
        apiResponse.isSuccess = false;
        return Observable.throw(apiResponse);//.throw(error);
    }

    //   protected mergeOptions(url: string | Request, options?: RequestOptionsArgs): Observable<RequestOptionsArgs> {
 //       return Observable.create(observer => {

 //           var resourceUrl = (url instanceof Request) ? url.url : url;

 //           //let uri = encodeURI(resourceUrl);

 //           var resource = this.adal.GetResourceForEndpoint(resourceUrl);

 //           //this.adal.acquireToken(resource)
 //           //    .flatMap((token: string) => {
 //           //        if (options1.headers == null) {
 //           //            options1.headers = new Headers();
 //           //        }
 //           //        options1.headers.append('Authorization', 'Bearer ' + token);
 //           //        return this.http.request(url, options1)
 //           //            .catch(this.handleError);
 //           //    });


 //           this.adal.acquireToken(resource)
 //               .subscribe((token: string) => {
 //                   // Combine constructor default options with request options
 //                   let mergedOptions: RequestOptionsArgs;
 //                   if (this._defaultOptions) {
 //                       mergedOptions = Object.assign({}, this._defaultOptions);
 //                   } else {
 //                       mergedOptions = new RequestOptions();
 //                   }
 //                   if (!mergedOptions.headers) {
 //                       mergedOptions.headers = new Headers();
 //                   }

 //                   if (options) {
 //                       options.headers.forEach((values, name, headers) => {
 //                           mergedOptions.headers.set(name, values);
 //                       });
 //                       mergedOptions.method = options.method;
 //                       mergedOptions.body = options.body;
 //                       mergedOptions.search = options.search;
 //                   }

 //                   mergedOptions.headers.set('Authorization', `Bearer ${token}`);
 //                   observer.next(mergedOptions);
 //               }, error => {
 //                   observer.error(error);
 //               });
 //       });
 //   }

 //   /**
 //* Performs any type of http request. First argument is required, and can either be a url or
 //* a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
 //* object can be provided as the 2nd argument. The options object will be merged with the values
 //* of {@link BaseRequestOptions} before performing the request.
 //*/
 //   request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
 //       return this.mergeOptions(url, options)
 //           .flatMap<Response>(requestOptions => {
 //               if (!requestOptions.body) {
 //                   requestOptions.body = '';
 //               }
 //               return this.intercept(super.request(url, requestOptions));
 //           });
 //   }

 //   /**
 //    * Performs a request with `get` http method.
 //    */
 //   get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        
 //       return this.mergeOptions(url, options)
 //           .flatMap<Response>(requestOptions => {
 //               if (!requestOptions.body) {
 //                   requestOptions.body = '';
 //               }
 //               return super.get(url, requestOptions);
 //               //return this.intercept();
 //           });

 //       //return this.intercept(super.get(url, options));
 //   }

 //   /**
 //    * Performs a request with `post` http method.
 //    */
 //   post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
 //       return this.mergeOptions(url, options)
 //           .flatMap<Response>(requestOptions => {
 //               return this.intercept(super.post(url, body, requestOptions));
 //           });
 //   }

 //   /**
 //    * Performs a request with `put` http method.
 //    */
 //   put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
 //       return this.mergeOptions(url, options)
 //           .flatMap<Response>(requestOptions => {
 //               return this.intercept(super.put(url, body, requestOptions));
 //           });
 //   }

 //   /**
 //    * Performs a request with `delete` http method.
 //    */
 //   delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
 //       return this.mergeOptions(url, options)
 //           .flatMap<Response>(requestOptions => {
 //               return this.intercept(super.delete(url, requestOptions));
 //           });
 //   }

 //   /**
 //    * Performs a request with `patch` http method.
 //    */
 //   patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
 //       return this.mergeOptions(url, options)
 //           .flatMap<Response>(requestOptions => {
 //               return this.intercept(super.patch(url, body, requestOptions));
 //           });
 //   }

 //   /**
 //    * Performs a request with `head` http method.
 //    */
 //   head(url: string, options?: RequestOptionsArgs): Observable<Response> {
 //       return this.mergeOptions(url, options)
 //           .flatMap<Response>(requestOptions => {
 //               return this.intercept(super.head(url, requestOptions));
 //           });
 //   }

    private decrementRequestCount() {
        if (--this.currentRequests == 0) {
            this.progressBarService.complete();
        }
    }

    private incrementRequestCount() {
        if (this.currentRequests++ == 0) {
            this.progressBarService.start();
        }
    }

 //   private intercept(observable: Observable<Response>): Observable<Response> {
 //       this.incrementRequestCount();
 //       observable.subscribe(response => {
 //               this.decrementRequestCount();
 //               var httpStatus = response.status;
 //               var responseMessage = response.json();
 //               var notificationMessage = responseMessage.Message ? responseMessage.Message : "";
 //               this.handleResponse(httpStatus, notificationMessage);
 //           },
 //           error => {
 //               this.decrementRequestCount();
 //               var httpStatus = error.status;
 //               var responseMessage = error.statusTest;
 //               var notificationMessage = responseMessage ? responseMessage : "";
 //               this.handleResponse(httpStatus, notificationMessage);
 //           },
 //           () => {
 //               //this.decrementRequestCount();
 //           });
 //       return observable;
 //   }

    protected handleResponse(statusCode: number, notificationMessage: string) {
        switch (statusCode) {
            case 200:
                {
                    //this.notificationService.success("Success", notificationMessage);
                    break;
                }
            case 201:
                {
                    this.notificationService.info("Created", notificationMessage);
                    break;
                }
            case 204:
                {
                    this.notificationService.info("Success", "Operation Completed successfully");
                    break;
                }
            case 400:
                {
                    this.notificationService.error("BadRequest", notificationMessage);
                    break;
                }
            case 401:
                {
                    this.notificationService.error("UnAuthorized", notificationMessage);
                    break;
                }
            case 409:
                {
                    this.notificationService.error("Conflict", notificationMessage);
                    break;
                }
            case 415:
                {
                    this.notificationService.error("UnSupported MediaType", notificationMessage);
                    break;
                }
            case 500:
            case 502:
                {
                    this.notificationService.error("Error", notificationMessage);
                    break;
                }
            default:
        {
            this.notificationService.error("Error", notificationMessage);
        }
        };
    }

 //   //this will force the call to be made immediately..  
 //       //observable.subscribe(
 //       //    null,
 //       //    null,
 //       //    () => {//this.decrementRequestCount()
 //       //    }
 //       //  );
 //       //return observable

 //       //private getProgressBarSubscribedobserver(response: Observable<Response>) {
 //   //    response.subscribe(null, error => {
 //   //        this.decrementRequestCount();
 //   //    }, () => {

 //   //    });
 //   //    return response;
 //   //}
}


// WEBPACK FOOTER //
// ./app/services/adal.http.service.ts